/** A realm role in plain words (Administration › Users & roles names), falling back to the role id. */
export function roleLabel(t: (k: string, o?: Record<string, unknown>) => string, role: string): string {
  return t(`users.roleName.${role}`, { defaultValue: role.replace(/-/g, " ") });
}
